// import { IResourceComponentsProps } from "@refinedev/core";
// import { MuiEditInferencer } from "@refinedev/inferencer/mui";

// export const CasseEdit: React.FC<IResourceComponentsProps> = () => {
//   return (
//     <MuiEditInferencer
//       fieldTransformer={(field: any) => {
//         if (["locale", "updatedAt", "publishedAt"].includes(field.key)) {
//           return false;
//         }

//         return field;
//       }}
//     />
//   );
// };

import { Box, TextField } from "@mui/material";
import { useTranslation } from "@refinedev/core";
import { Edit } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";

export const CasseEdit = () => {

  const { translate } = useTranslation();

  const {
    saveButtonProps,
    refineCore: { queryResult },
    register,
    formState: { errors },
  } = useForm();
  console.log({ queryResult });

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("quantity", {
            required: translate('this-field-is-required'),
            valueAsNumber: true,
          })}
          error={!!(errors as any)?.quantity}
          helperText={(errors as any)?.quantity?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Quantity"
          name="quantity"
        />
        <TextField
          {...register("container")}
          helperText={(errors as any)?.container?.message}
          value={queryResult?.data?.data?.container?.name ?? ""}
          margin="normal"
          fullWidth
          disabled
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Container"
          name="container"
        />
        {/*
                    DatePicker component is not included in "@refinedev/mui" package.
                    To use a <DatePicker> component, you can follow the official documentation for Material UI.

                    Docs: https://mui.com/x/react-date-pickers/date-picker/#basic-usage
                */}
        <TextField
          {...register("createdAt", {
            required: translate('this-field-is-required'),
          })}
          error={!!(errors as any)?.createdAt}
          helperText={(errors as any)?.createdAt?.message}
          margin="normal"
          fullWidth
          disabled
          InputLabelProps={{ shrink: true }}
          label="Created At"
          name="createdAt"
        />
      </Box>
    </Edit>
  );
};
